import { styleOverrides } from "./styleOverrides";

const MuiTabs = {
  styleOverrides,
};

export { MuiTabs };
